import { useMutation, useQueryClient } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

type TParams = {
	onSuccess?: () => void;
};

export const useRequestCancelBulkNotificationCampaign = (params?: TParams) => {
	const queryClient = useQueryClient();
	const { isPending, mutateAsync, error } = useMutation({
		mutationFn: (campaignId: string) =>
			apiClient
				.post(routes.api.bulkNotificationCampaigns.cancel(campaignId))
				.then(handleApiResponse),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [routes.api.bulkNotificationCampaigns.base] });
			params?.onSuccess?.();
		},
	});

	return {
		isLoading: isPending,
		cancelCampaign: mutateAsync,
		error,
	};
};
